<template>
    <h3
        class="block font-bold text-gray-900"
        data-spec-class="card_list-title"
    >
        <slot></slot>
    </h3>
</template>
